import site from "../../content/data/site.json"

// Static snapshot of the WordPress GLOBAL_MAIN menu (previously a WPGraphQL static query)
export default function useQueryGlobalMainNav() {
  return { wpMenu: site.mainMenu }
}
